// UserRoleTabs — the All / Admins / Tutors / Students switch above the Users table.
import type { Role } from "@dm-lms/shared/types";

const TABS: ReadonlyArray<{ label: string; role: Role | undefined }> = [
  { label: "All",      role: undefined },
  { label: "Admins",   role: "admin" },
  { label: "Tutors",   role: "tutor" },
  { label: "Students", role: "student" },
];

interface UserRoleTabsProps {
  active:   Role | undefined;
  onSelect: (role: Role | undefined) => void;
}

export default function UserRoleTabs({ active, onSelect }: UserRoleTabsProps) {
  return (
    <div role="tablist" aria-label="Filter users by role" className="mb-4 flex flex-wrap gap-2">
      {TABS.map((tab) => {
        const selected = tab.role === active;
        return (
          <button
            key={tab.label}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => { onSelect(tab.role); }}
            className={`rounded-md border px-3 py-1.5 text-sm font-medium ${
              selected
                ? "border-dm-navy bg-dm-navy text-white"
                : "border-gray-300 text-dm-navy hover:bg-gray-50"
            }`}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
